import { cn } from '@/lib/utils';
import React from 'react';

export const VSeparator: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
}) => {
  return <div className={cn('border-r-[1px] border-neutral-40', className)} />;
};
VSeparator.displayName = 'VSeparator';
